let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("94M02")).then(() => parcelRequire('497YX'));